// components/PaidWatermark.js
import React from 'react';
import styles from './index.module.css';

const PaidWatermark = () => {
  return <div className={styles.watermark}>PAID</div>;
};

export default PaidWatermark;
